import { render } from "./InStockList.vue?vue&type=template&id=6943c152&scoped=true"
import script from "./InStockList.vue?vue&type=script&lang=js"
export * from "./InStockList.vue?vue&type=script&lang=js"

import "./InStockList.vue?vue&type=style&index=0&id=6943c152&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6943c152"],['__file',"src/views/h5/luqiao/stockOrder/inStock/InStockList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6943c152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6943c152', __exports__)) {
    api.reload('6943c152', __exports__)
  }
  
  module.hot.accept("./InStockList.vue?vue&type=template&id=6943c152&scoped=true", () => {
    api.rerender('6943c152', render)
  })

}


export default __exports__